import React from "react";
import NewAddress from "./New-address";
const Addresspage = () =>{
return(
    <div>
        <NewAddress/>
   </div>
    );
}
export default Addresspage;